import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from '@airtel/air-design-system';
export var SearchBar = props => {
  var onTextChangeHandler = props.onTextChangeHandler,
    placeholderText = props.placeholderText,
    postIconName = props.postIconName;
  return _jsx(Input, Object.assign({
    placeholder: placeholderText,
    onChangeText: onTextChangeHandler,
    appendItems: {
      isPressable: false,
      prefixIcon: {
        iconName: postIconName,
        isActionable: false
      }
    },
    showAppend: true
  }, props));
};